import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { useEffectEvent } from "@faire/web--source/ui/hooks/useEffectEvent";
import { useEffect } from "react";
export var useVisibilityChangeEvent = function(callback) {
    var callbackRef = useEffectEvent(callback);
    useEffect(function() {
        var handleOnEvent = function(event) {
            callbackRef(getWindowOrThrow().document.visibilityState, event);
        };
        getWindowOrThrow().addEventListener("visibilitychange", handleOnEvent);
        return function() {
            getWindowOrThrow().removeEventListener("visibilitychange", handleOnEvent);
        };
    }, [
        callbackRef
    ]);
};
